import React, { Component } from 'react';
import ServiceCalls from '../utils/serviceCalls.js';
import RoleUtils from '../utils/roleUtils.js';
import RequestWorklist from '../components/RequestWorklist';

import '../styles/Vendor.css';
import { Loading } from '../components/Loading';
export class VendorWorklist extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            hasAccess: false,
            isLoading: true,
            worklist: {},
            isReadOnly: true,
            hasAdminAccess: false,
            showAllResults: true
        };
    } 

    componentDidMount() {
        const { currentCompanyId, currentUser } = this.props;
        var hasAdminAccess = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumWorklistRoles());
        var showAll = (hasAdminAccess !== true);
        if (hasAdminAccess) {
            var curDisplay = sessionStorage.getItem("reqShAllResults");
            showAll = (curDisplay) ? curDisplay.toUpperCase() === "TRUE" : showAll;
        }
        //US6803555 - 3-27-24 Unknown release  console.log(`Worklist Loaded for: ${currentCompanyId}`);
        this.onChange(hasAdminAccess, showAll);
    }

    componentDidUpdate(prevProps, prevState) {
        const { currentCompanyId, currentUser } = this.props;
        if (prevProps.currentCompanyId !== currentCompanyId) {
            var hasAdminAccess = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumWorklistRoles());
            console.log(`Worklist Updated - Old Sup: ${prevProps.currentCompanyId}  - new Sup: ${currentCompanyId}`);
            var showAll = (hasAdminAccess !== true);
            if (hasAdminAccess) {
                var curDisplay = sessionStorage.getItem("reqShAllResults");
                showAll = (curDisplay) ? curDisplay.toUpperCase() === "TRUE" : showAll;
            }
            this.onChange(hasAdminAccess, showAll);
        }
       // else {
            //US6803555 - 3-27-24 Unknown release
        //    console.log(`Worklist NOT Updated for: ${currentCompanyId}`);
      //  }
    }  

    onChange(hasAdminAccess,showAllResults) {
        const { currentCompanyId,currentUser } = this.props;
        this.setState({           
            isLoading: true,            
        });
    
        ServiceCalls.checkWorklistAccess(Number(currentCompanyId)).then(function (data) {
            if (data) {  
                var savedCt = sessionStorage.getItem("wlRowCt");
                var resultRowCount = (savedCt) ? Number(savedCt) : 25;
                var savedFilterTxt = sessionStorage.getItem("wlFltrTxt");
                var filterText = (savedFilterTxt) ? savedFilterTxt : "";
                var savedSort = sessionStorage.getItem("wlSort");
                var sortText = (savedSort) ? savedSort : '{"col":"createdDt","dir":false}';
                ServiceCalls.getWorklistItems(Number(currentCompanyId), showAllResults).then(function (results) {  
                    console.log("Worklist results (JSON):", JSON.stringify(results));
                    if (results.length > 0) {
                        //Check Access/Auth errors from server in first record
                        if (results[0].isSuccessful === false) {
                            console.log(`Error fetching worklist items- NOT SUCCESSFUL`);
                            this.setState({
                                hasAccess: data,
                                isLoading: false,
                                isReadOnly: true,
                                hasAdminAccess: false,
                                showAllResults: false,
                                worklist: [],
                                resultsPageCount: resultRowCount,
                                filterText: filterText,
                                sortText: sortText
                            });
                        }
                        else {
                            var readOnly = (!(RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allWorklistRoles())))
                                || RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.optumAdminPerms()); 
                                this.setState({
                                    hasAccess: data,
                                    isLoading: false,
                                    worklist: results,
                                    isReadOnly: readOnly,
                                    hasAdminAccess: hasAdminAccess,
                                    showAllResults: showAllResults,
                                    resultsPageCount: resultRowCount,
                                    filterText: filterText,
                                    sortText: sortText
                                });                            
                        }
                    }
                    else {
                        //NO ITEMS RETURNED
                        this.setState({
                            hasAccess: data,
                            isLoading: false,
                            worklist: [],
                            isReadOnly: true,
                            hasAdminAccess: hasAdminAccess,
                            showAllResults: showAllResults,
                            resultsPageCount: resultRowCount,
                            filterText: filterText,
                            sortText: sortText
                        });
                    }
                }.bind(this));
            }
            else {
                this.setState({ hasAccess: false, isLoading: false });
            }
        }.bind(this));
    }


    render() {
        const { hasAccess, isLoading, worklist, isReadOnly, hasAdminAccess, showAllResults, resultsPageCount, filterText, sortText } = this.state;      
        const vendorForm = (isLoading)
            ? <div style={{ margin: "auto", width: "250px" }}>
                <h3 className="primaryText">Worklist</h3>
                <Loading />
            </div>
            :(hasAccess === true && worklist) ?
            <>
                    <RequestWorklist vendorData={worklist} isReadOnly={isReadOnly} hasAdminAccess={hasAdminAccess} showAllResults={showAllResults} onWorklistChange={this.onChange} resultsPageCount={resultsPageCount} filterText={filterText} sortText={sortText} />
            </>
            :  <h3 style={{ marginTop: "10px" }}>You do not have access rights to this page.</h3>;

        return (
            <>
                {vendorForm}
            </>
        );
    }
}
